import React from 'react';
import ReactDOM from 'react-dom/client';
import { persistStore } from 'redux-persist';
import { store } from 'reducer/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'theme/theme.scss';

// 讀取i18n設定
import './i18n/setting';
import App from 'view/App';
import Toaster from 'tradevan-ui/Toaster';
import LoadingMask from 'components/LoadingMask';

const root = ReactDOM.createRoot(
  document.getElementById('wrapper') as HTMLElement,
);

// const persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <Toaster position="bottom-left" />
    {/* <PersistGate loading={null} persistor={persistor}> */}
    <App />
    <LoadingMask />
    {/* </PersistGate> */}
  </Provider>,
);
